import * as Sentry from '@sentry/react';

import { env } from './config/env';

if (env.sentryDsn) {
  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.appEnv,
    release: env.commitSha,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
  });
}
